module.exports = __webpack_public_path__ + "static/img/btt1.75dd177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btt1.png
// module id = SYNg
// module chunks = 1